import React from 'react';
import { useNavigate } from 'react-router';
import { Button } from '@/components/ui/button';
import { ChevronLeft } from 'lucide-react';
import { cn } from '@/museum-app/utils/cn';

interface BackButtonProps {
  to: string;
  text: string;
  ariaLabel: string;
  className?: string;
}

export const BackButton: React.FC<BackButtonProps> = ({
  to,
  text,
  ariaLabel,
  className = '',
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(to);
  };

  return (
    <Button
      variant="ghost"
      onClick={handleBack}
      className={cn("text-primary mb-6 flex items-center p-0 hover:underline bg-gray-100", className)}
      aria-label={ariaLabel}
    >
      <ChevronLeft className="mr-1 h-5 w-5" />
      {text}
    </Button>
  );
};
